import { Component } from 'react';
import { Flow } from 'flow-react';
import { observer } from "mobx-react";
import { Carousel, Row, Col} from 'react-bootstrap';
import './Slider.css';


const Slider = observer(
  class Slider extends Component {
	
		chains = ["France 2","France 3","France 4","France 5","Réseau la 1ère","Outre-Mer la 1ère","france.tv distribution","france.tv","Lumni","france.tv Slash"];
		chacls = ["france_2","france_3","france_4","france_5","reseau_la_1ere","outre_mer_la_1ere","france_tv_distribution","france_tv","lumni","france_tv_slash"];
		
		getIcClass = (md) => {
			let ic = 'france_tv';
			if(this.chains.indexOf(md) > -1)
				ic = this.chacls[this.chains.indexOf(md)];
			return 'sliconcont sl_'+ic;
		}
	
	
			
		render() {
			if(this.props.carouselclips.length < 1) 
				return null;
			return (
				<Carousel fade className="mainslider">
					{this.props.carouselclips.map(si => {
						return(
							<Carousel.Item key={si.clid}>
									<div className={this.getIcClass(si.chains)}></div>
								<img
									className="d-block w-100"
									src={si.url}
									alt={si.title}
									onClick={()=>{ this.props.clipclickcb(si.clid) }}
								/>
								<Carousel.Caption>
									<h2>{si.title}</h2>
									<h4>{si.subtitle}</h4>
								</Carousel.Caption>
							</Carousel.Item>
						)}	
					)}		
				</Carousel>
			)
		}
		
	}
)

export default Flow.injectFlow(Slider);